import { __assign, __awaiter, __generator } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Button } from "@mui/material";
import { useTheme } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useStoreFileViewerContext } from "../../hooks/context";
import { alertOnError } from "../AlertSnackbar/hooks";
import PasswordConfirmationModal from "../PasswordConfirmationModal";
var RemoveFilePasswordButton = function (_a) {
    var object = _a.object, ButtonProps = _a.ButtonProps, _b = _a.onClose, onClose = _b === void 0 ? function () { } : _b;
    var theme = useTheme();
    var _c = useStoreFileViewerContext(), apiRef = _c.apiRef, reload = _c.reload;
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var handleCancel = function () {
        setOpen(false);
        onClose();
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ sx: { width: "100%" }, color: "error", variant: "text", startIcon: _jsx(LockOutlinedIcon, { fontSize: "small", color: "error" }), onClick: function () { return setOpen(true); } }, ButtonProps, { children: "Remove password" })), _jsx(PasswordConfirmationModal, { open: open, onClose: handleCancel, description: "Removing the password for ".concat(object.name || object.id, "."), title: "Removing password", onContinue: function (password) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        if (!apiRef.update)
                            return [2 /*return*/];
                        return [2 /*return*/, apiRef
                                .update({ id: object.id, remove_password: password })
                                .then(function () {
                                handleCancel();
                                reload();
                            })
                                .catch(function (err) {
                                alertOnError(err);
                            })];
                    });
                }); } })] }));
};
export default RemoveFilePasswordButton;
